module.exports = __webpack_public_path__ + "static/media/One.all.dc6fcccd.jpg";